import type { ReactElement } from "react";
import { Card } from "@olivahealth/oli-ui";

interface SkeletonProps {
  variant?: "default" | "compact";
}

export function CompanionSessionCardSkeleton({
  variant = "default",
}: SkeletonProps): ReactElement {
  if (variant === "default") {
    return (
      <Card
        backgroundClassName="bg-neutral-800"
        border={false}
        padding="md"
        rounding="2xl"
        fullHeight={false}
      >
        <div className="flex flex-col gap-y-3 animate-pulse">
          <div className="flex flex-col gap-y-1">
            {/* Date skeleton */}
            <div className="h-4 bg-white/30 rounded w-36"></div>

            {/* Title skeleton */}
            <div className="h-5 bg-white/30 rounded w-48 mt-1"></div>

            {/* Summary skeleton */}
            <div className="space-y-2 mt-1">
              <div className="h-4 bg-white/20 rounded w-full"></div>
              <div className="h-4 bg-white/20 rounded w-3/4"></div>
            </div>
          </div>

          {/* Button skeleton */}
          <div className="flex justify-start mt-2">
            <div className="h-8 bg-white/20 rounded w-20"></div>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card
      backgroundClassName="bg-neutral-800"
      border={false}
      padding="md"
      rounding="2xl"
      fullHeight={false}
    >
      <div className="flex items-center justify-between animate-pulse">
        <div className="flex flex-col gap-y-1">
          {/* Date skeleton */}
          <div className="h-4 bg-white/30 rounded w-36"></div>

          {/* Title skeleton */}
          <div className="h-4 bg-white/20 rounded w-48"></div>
        </div>

        {/* Chevron skeleton */}
        <div className="h-5 w-5 bg-white/20 rounded"></div>
      </div>
    </Card>
  );
}
